// Port of api/fuel/app/classes/insights/collection/year.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'year',
    default_: false,
    insight: ['year'],
    run: function(type, owner, userIndex, detail, filter, vars) {

        var year = (vars && vars.year !== undefined) ? vars.year : false

        var year_type = (filter.year !== undefined) ? filter.year : 'version'
        var games = []

        var collectionIndex = Util.queryFast('\
            SELECT \
                g.game_id AS g, \
                v.game_version_id AS v, \
                g.game_published AS gy, \
                v.game_version_year AS vy, \
                v.game_version_name AS vn \
            FROM \
                ( \
                    collection c \
                    JOIN \
                    game g \
                    ON \
                    c.game_id = g.game_id \
                ) \
                LEFT JOIN \
                game_version v \
                ON \
                c.game_version_id = v.game_version_id \
            WHERE \
                c.user_id IN (' + Util.in(userIndex) + ') \
                AND \
                c.collection_own = 1 \
                AND \
                g.game_type = 1 \
            GROUP BY \
                g.game_id, \
                v.game_version_id \
            ORDER BY \
                g.game_name \
        ')

        for (var i = 0; i < collectionIndex.length; i++) {
            var item = collectionIndex[i]

            var collectionYear = (item.vy && year_type === 'version') ? parseInt(item.vy, 10) : parseInt(item.gy, 10)

            if (collectionYear == year) {

                this._references.games.push(item.g)

                games.push({
                    id: parseInt(item.g, 10),
                    subtext: item.v ? item.vn : ''
                })

            }
        }

        return {
            year: year,
            games: games
        }

    }
})
